import React from 'react';
import CrudPage from '../../../components/CrudPage';
import { Badge } from '../../../components/common';
import { AUDIT_COLUMNS } from '../../../config/columns';
import { accountCodeService } from '../../../services/resources';

export default function AccountCodePage({ onToast }) {
  return (
    <CrudPage
      title="Account Code"
      formCode="ACCOUNT_CODE"
      service={accountCodeService}
      onToast={onToast}
      searchKeys={['account_code', 'account_name', 'account_type', 'description']}
      columns={[
        { key: 'account_code', label: 'Code' },
        { key: 'account_name', label: 'Name' },
        {
          key: 'account_type',
          label: 'Type',
          render: (r) => (
            <Badge tone={r.account_type === 'DEBIT' ? 'blue' : 'gray'}>{r.account_type}</Badge>
          ),
        },
        { key: 'description', label: 'Description' },
        ...AUDIT_COLUMNS,
      ]}
      fields={[
        // account_code locks on edit; account_name stays editable.
        { key: 'account_code', label: 'Account Code', type: 'text', required: true, immutableOnEdit: true },
        { key: 'account_name', label: 'Account Name', type: 'text', required: true, uppercase: true },
        {
          key: 'account_type',
          label: 'Account Type',
          type: 'select',
          required: true,
          options: [
            { value: 'DEBIT', label: 'DEBIT' },
            { value: 'CREDIT', label: 'CREDIT' },
          ],
        },
        { key: 'description', label: 'Description', type: 'textarea' },
      ]}
    />
  );
}
